const SvgNoTokens = (props) => (
  <svg
    width="153"
    height="175"
    viewBox="0 0 153 175"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M76 141.825C114.762 141.825 146.186 110.4 146.186 71.5001C146.186 32.5997 114.623 1.17499 76 1.17499C37.2382 1.17499 5.81348 32.5997 5.81348 71.5001C5.81348 110.4 37.2382 141.825 76 141.825Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_7885_6311)">
      <path
        d="M119.689 120.626L39.3887 125.904L32.8952 27.114C32.6839 23.8981 35.1008 21.1037 38.3313 20.8912L96.0694 17.0962L113.916 32.7958L119.689 120.626Z"
        fill="url(#paint0_linear_7885_6311)"
      />
    </g>
    <path
      d="M96.1154 17.7969L96.6382 25.7516C96.9593 30.6369 101.18 34.3368 106.065 34.0156L113.962 33.4966"
      fill="#D5DDEA"
    />
    <g opacity="0.5">
      <path
        d="M71.17 53.9384L57.3948 55.0057C56.8034 55.0546 56.3579 54.6468 56.3348 54.2039C56.3079 53.6872 56.7956 53.2762 57.3025 53.2341L71.0777 52.167C71.6691 52.1179 72.1147 52.5258 72.1377 52.9686C72.1608 53.4116 71.7614 53.8893 71.17 53.9384Z"
        fill="#D6DCE8"
      />
      <path
        d="M72.9366 80.8172L59.1614 81.8845C58.57 81.9334 58.1245 81.5256 58.1014 81.0827C58.0745 80.566 58.5622 80.155 59.0691 80.113L72.8443 79.0458C73.4357 78.9967 73.8812 79.4046 73.9043 79.8474C73.9273 80.2903 73.528 80.7681 72.9366 80.8172Z"
        fill="#D6DCE8"
      />
      <path
        d="M103.777 51.7733L87.895 53.0022C87.3038 53.0507 86.8585 52.6472 86.8353 52.209C86.8084 51.6979 87.2959 51.2912 87.8027 51.2497L103.601 50.0276C104.192 49.9791 104.637 50.3826 104.66 50.8208C104.768 51.2519 104.369 51.7247 103.777 51.7733Z"
        fill="#EAECF3"
      />
      <path
        d="M105.544 78.6524L89.6618 79.8814C89.0705 79.9299 88.6252 79.5264 88.602 79.0882C88.5751 78.577 89.0627 78.1704 89.5694 78.1288L105.367 76.9068C105.959 76.8583 106.404 77.2618 106.427 77.6999C106.535 78.1311 106.135 78.6039 105.544 78.6524Z"
        fill="#EAECF3"
      />
      <path
        d="M94.5541 72.3811L78.6719 73.6096C78.0806 73.6581 77.6353 73.2547 77.6123 72.8167C77.5852 72.3058 78.0728 71.8992 78.5795 71.8577L94.4618 70.6292C95.053 70.5808 95.4985 70.9841 95.5215 71.4221C95.5484 71.933 95.0609 72.3395 94.5541 72.3811Z"
        fill="#D6DCE8"
      />
      <path
        d="M96.3208 99.2602L80.4386 100.489C79.8473 100.537 79.4021 100.134 79.379 99.6958C79.352 99.1848 79.8395 98.7784 80.3463 98.7369L96.2285 97.5082C96.8198 97.4598 97.2651 97.8631 97.2883 98.3012C97.3151 98.8121 96.8276 99.2186 96.3208 99.2602Z"
        fill="#D6DCE8"
      />
      <path
        d="M83.4642 53.1217L75.7592 53.7074C75.1667 53.7583 74.7204 53.3342 74.6974 52.8736C74.6703 52.3365 75.1589 51.909 75.6666 51.8655L83.3717 51.2798C83.964 51.2288 84.4103 51.653 84.4335 52.1134C84.5451 52.6433 84.0567 53.0707 83.4642 53.1217Z"
        fill="#AAB2C5"
      />
      <path
        d="M85.2301 80.0007L77.5251 80.5862C76.9326 80.6372 76.4863 80.2132 76.4632 79.7528C76.4362 79.2156 76.9248 78.7882 77.4326 78.7446L85.1376 78.1591C85.73 78.1082 86.1762 78.5322 86.1994 78.9926C86.311 79.5225 85.8225 79.9498 85.2301 80.0007Z"
        fill="#AAB2C5"
      />
      <path
        d="M51.9457 55.1425L46.2702 55.6367C45.6773 55.6883 45.2305 55.2585 45.2075 54.792C45.1804 54.2475 45.5846 53.8217 46.1775 53.77L51.853 53.2758C52.4459 53.2243 52.8927 53.654 52.9157 54.1206C52.9428 54.665 52.5385 55.0908 51.9457 55.1425Z"
        fill="#AAB2C5"
      />
      <path
        d="M53.7123 82.0212L48.0368 82.5154C47.4439 82.567 46.9971 82.1373 46.9741 81.6706C46.947 81.1262 47.3512 80.7004 47.9441 80.6488L53.6196 80.1546C54.2125 80.1029 54.6593 80.5327 54.6823 80.9994C54.7094 81.5438 54.3051 81.9695 53.7123 82.0212Z"
        fill="#AAB2C5"
      />
      <path
        d="M74.2985 60.4392L66.0033 61.0729C65.411 61.1235 64.9648 60.7014 64.9416 60.243C64.9147 59.7082 65.403 59.2828 65.9106 59.2393L74.2061 58.6056C74.7983 58.5549 75.2445 58.977 75.2676 59.4354C75.3754 59.8867 74.8908 60.3884 74.2985 60.4392Z"
        fill="#D6DCE8"
      />
      <path
        d="M76.066 87.3181L67.7706 87.9519C67.1784 88.0026 66.7323 87.5805 66.7091 87.1221C66.6822 86.5873 67.1705 86.1616 67.6781 86.1182L75.9735 85.4844C76.5658 85.4337 77.012 85.8559 77.035 86.3144C77.1429 86.7656 76.6583 87.2675 76.066 87.3181Z"
        fill="#D6DCE8"
      />
      <path
        d="M99.9261 58.7799L78.8921 60.261C78.3012 60.3087 77.856 59.9117 77.833 59.4806C77.8059 58.9777 78.2933 58.5776 78.8 58.5367L99.8338 57.0557C100.425 57.008 100.87 57.405 100.893 57.8359C100.916 58.2671 100.433 58.7391 99.9261 58.7799Z"
        fill="#D6DCE8"
      />
      <path
        d="M101.693 85.6589L80.6589 87.1402C80.0679 87.1878 79.6228 86.7908 79.5997 86.3597C79.5727 85.8568 80.0601 85.4565 80.5667 85.4158L101.6 83.9345C102.191 83.8868 102.637 84.2838 102.66 84.7149C102.683 85.146 102.199 85.618 101.693 85.6589Z"
        fill="#D6DCE8"
      />
      <path
        d="M60.5611 61.1925L46.7071 62.3359C46.1158 62.3846 45.6704 61.9785 45.6472 61.5375C45.6203 61.0229 46.1078 60.6135 46.6147 60.5717L60.4688 59.4283C61.0602 59.3794 61.5056 59.7857 61.5287 60.2267C61.5519 60.6677 61.1525 61.1438 60.5611 61.1925Z"
        fill="#EAECF3"
      />
      <path
        d="M62.3278 88.0718L48.4738 89.2152C47.8825 89.2639 47.4371 88.8578 47.4139 88.4166C47.387 87.902 47.8746 87.4926 48.3815 87.4508L62.2355 86.3075C62.8269 86.2587 63.2724 86.6648 63.2954 87.106C63.3186 87.547 62.9193 88.0229 62.3278 88.0718Z"
        fill="#EAECF3"
      />
      <path
        d="M85.6049 66.2175L66.436 67.6928C65.845 67.7404 65.3997 67.3433 65.3767 66.9121C65.3498 66.4091 65.837 66.0088 66.3436 65.9679L85.5969 64.4858C86.1879 64.4381 86.6332 64.8352 86.6562 65.2664C86.6831 65.7695 86.1958 66.1697 85.6049 66.2175Z"
        fill="#AAB2C5"
      />
      <path
        d="M87.3716 93.0965L68.2027 94.5718C67.6117 94.6195 67.1664 94.2224 67.1434 93.7911C67.1165 93.2881 67.6038 92.8879 68.1104 92.8471L87.3638 91.3649C87.9547 91.3172 88.3999 91.7143 88.4229 92.1455C88.45 92.6485 87.9626 93.0487 87.3716 93.0965Z"
        fill="#AAB2C5"
      />
      <path
        d="M60.9955 67.8027L47.1414 68.946C46.55 68.995 46.1046 68.5887 46.0815 68.1476C46.0545 67.6331 46.5422 67.2237 47.0491 67.1819L60.9031 66.0385C61.4944 65.9896 61.94 66.3959 61.963 66.8369C61.9861 67.278 61.5869 67.7539 60.9955 67.8027Z"
        fill="#D6DCE8"
      />
      <path
        d="M62.7621 94.682L48.908 95.8254C48.3166 95.8741 47.8712 95.468 47.8481 95.0268C47.8211 94.5123 48.3088 94.103 48.8157 94.0611L62.6697 92.9177C63.2611 92.8689 63.7066 93.2751 63.7296 93.7162C63.7527 94.1572 63.3535 94.6331 62.7621 94.682Z"
        fill="#D6DCE8"
      />
      <path
        d="M73.3988 73.7448L62.8269 74.5615C62.235 74.6114 61.7891 74.1957 61.7661 73.7443C61.7392 73.2176 62.2272 72.7986 62.7344 72.7559L73.3063 71.9392C73.8982 71.8893 74.3439 72.305 74.3671 72.7564C74.394 73.2831 73.9905 73.6948 73.3988 73.7448Z"
        fill="#EAECF3"
      />
      <path
        d="M75.1663 100.624L64.5943 101.441C64.0025 101.491 63.5566 101.075 63.5335 100.623C63.5065 100.097 63.9946 99.6777 64.5018 99.6349L75.0738 98.8182C75.6657 98.7682 76.1114 99.184 76.1346 99.6355C76.1615 100.162 75.758 100.574 75.1663 100.624Z"
        fill="#EAECF3"
      />
      <path
        d="M56.1211 74.8252L47.5779 75.5535C46.9858 75.604 46.5398 75.1838 46.5166 74.7277C46.4897 74.1954 46.978 73.7721 47.4855 73.7288L56.0286 73.0005C56.6208 72.9499 57.0668 73.3701 57.0899 73.8264C57.2014 74.3513 56.7133 74.7747 56.1211 74.8252Z"
        fill="#AAB2C5"
      />
      <path
        d="M57.887 101.704L49.3438 102.433C48.7516 102.483 48.3056 102.063 48.2826 101.607C48.2555 101.075 48.7438 100.651 49.2513 100.608L57.7945 99.8796C58.3865 99.8291 58.8327 100.249 58.8557 100.705C58.9672 101.23 58.479 101.654 57.887 101.704Z"
        fill="#AAB2C5"
      />
      <path
        d="M84.4008 42.5997L45.5924 45.4272C45.0019 45.4723 44.5572 45.097 44.5341 44.6894C44.5073 44.2139 44.9941 43.8357 45.5002 43.797L84.3084 40.9697C84.899 40.9246 85.3438 41.2999 85.3669 41.7074C85.3937 42.1829 84.9911 42.5547 84.4008 42.5997Z"
        fill="#AAB2C5"
      />
    </g>
    <path
      d="M60.529 62.4946L60.8577 67.4953C60.9352 68.6719 60.7567 70.1607 58.2811 70.3235L57.7311 70.3595L58.079 75.6543L58.6292 75.6182C60.2796 75.5097 61.4378 76.3199 61.5538 78.0848L61.9018 83.3796C62.2112 88.086 64.8802 90.8649 69.5562 90.5576L71.4816 90.431L71.1335 85.1362L69.2081 85.2627C68.383 85.317 67.2634 85.0951 67.128 83.0361L66.7413 77.153C66.6059 75.0939 65.6842 73.6774 63.9757 72.9033C65.568 71.9124 66.2772 70.0933 66.1612 68.3284L65.7746 62.4453C65.6586 60.6802 66.7201 60.0197 67.5453 59.9655L69.1957 59.857L68.8283 54.2679L66.9029 54.3946C62.502 54.6838 60.2004 57.494 60.529 62.4946Z"
      fill="#989FB0"
    />
    <path
      d="M90.6283 65.3055L90.3056 60.3966C90.0019 55.7764 87.2803 53.0552 82.4979 53.3696L80.5288 53.499L80.8704 58.6967L82.5583 58.5857C83.4022 58.5302 84.5465 58.745 84.6793 60.7664L85.059 66.5416C85.1918 68.5629 86.1306 69.9512 87.8754 70.7066C86.5258 71.6653 85.7958 73.4534 85.9097 75.186L86.2893 80.9612C86.4222 82.9825 85.0346 83.3638 84.4719 83.4007L82.5028 83.5301L82.8444 88.7278L84.8136 88.5984C89.5959 88.284 91.9569 85.5187 91.6343 80.6099L91.3116 75.7009C91.1977 73.9683 91.9847 73.0465 93.6725 72.9356L94.2351 72.8986L93.8935 67.7009L93.3309 67.7379C91.643 67.8488 90.7422 67.038 90.6283 65.3055Z"
      fill="#989FB0"
    />
    <defs>
      <filter
        id="filter0_d_7885_6311"
        x="0.379143"
        y="0.844601"
        width="151.813"
        height="173.814"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="16.2516" />
        <feGaussianBlur stdDeviation="16.2516" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7885_6311"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7885_6311"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_7885_6311"
        x1="72.4761"
        y1="16.2162"
        x2="79.5867"
        y2="124.395"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoTokens;
